// extracted by mini-css-extract-plugin
export default {"title":"PlansAndSubscription_title__fNGeo","header":"PlansAndSubscription_header__Ww+Hk"};